import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from '../../api/axiosInstance';
import UserLayout from "../../components/user/UserLayout";
import {
  Card,
  Spinner,
  Alert,
  Badge,
  Row,
  Col,
  Button,
} from "react-bootstrap";
import {
  FaFlask,
  FaTools,
  FaCheckCircle,
  FaBook,
  FaArrowLeft,
} from "react-icons/fa";

const FormulaDetailPage = () => {
  const { id } = useParams();
  const [formula, setFormula] = useState(null);
  const [loading, setLoading] = useState(true);

  const formatContent = (text) => {
    if (!text) return "";

    // Eğer HTML ise dokunma
    if (text.includes("<") && text.includes(">")) return text;

    // Satırlara göre madde işaretine çevir
    return (
      "<ul>" +
      text
        .split("\n")
        .filter((line) => line.trim() !== "")
        .map((line) => `<li>${line}</li>`)
        .join("") +
      "</ul>"
    );
  };

  const loadFormula = async () => {
    try {
      const res = await api.get(`/formulas/${id}`);
      setFormula(res.data);
    } catch (err) {
      console.error("Formül alınamadı:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadFormula();
  }, [id]);

  if (loading)
    return (
      <UserLayout>
        <div className="d-flex justify-content-center py-5">
          <Spinner animation="border" />
        </div>
      </UserLayout>
    );

  if (!formula)
    return (
      <UserLayout>
        <Alert variant="danger" className="mt-4">
          Formül bulunamadı.
        </Alert>
      </UserLayout>
    );

  return (
    <UserLayout>

      {/* HERO HEADER */}
      <div
        className="p-4 rounded-4 shadow-sm mb-4 text-white"
        style={{
          background:
            "linear-gradient(135deg, #2D8A7A 0%, #56B6A5 50%, #7DD1C0 100%)",
        }}
      >
        <h2 className="fw-bold mb-2">{formula.formulationName}</h2>

        {formula.indication && (
          <Badge bg="light" text="dark" className="fw-semibold">
            {formula.indication}
          </Badge>
        )}

        <p className="mt-3 opacity-75">
          Bu formül içerik, hazırlanış ve kullanım bilgilerini içerir.
        </p>
      </div>

        {/* GERİ DÖN BUTONU */}
      <div className="mb-3">
        <Button
          as={Link}
          to="/panel/formulas"
          variant="outline-primary"
          className="rounded-pill"
        >
          <FaArrowLeft className="me-2" />
          Tüm Formüllere Dön
        </Button>
      </div>

      <Row className="g-4">
        <Col md={8}>
          {/* İçerik */}
          <Card id="content" className="p-4 shadow-sm mb-4 rounded-4">
            <h4 className="fw-bold mb-3 d-flex align-items-center">
              <FaFlask className="me-2 text-primary" /> İçerik
            </h4>

            <div
              className="text-muted"
              dangerouslySetInnerHTML={{
                __html: formatContent(formula.content),
              }}
            />
          </Card>

          {/* Hazırlanış */}
          <Card id="preparation" className="p-4 shadow-sm mb-4 rounded-4">
            <h4 className="fw-bold mb-3 d-flex align-items-center">
              <FaTools className="me-2 text-primary" /> Hazırlanış
            </h4>
            <p className="text-muted">
              {formula.preparation || "Hazırlanış bilgisi eklenmemiş."}
            </p>
          </Card>

          {/* Kullanım */}
          <Card id="usage" className="p-4 shadow-sm mb-4 rounded-4">
            <h4 className="fw-bold mb-3 d-flex align-items-center">
              <FaCheckCircle className="me-2 text-primary" /> Kullanım
            </h4>
            <p className="text-muted">
              {formula.usage || "Kullanım bilgisi eklenmemiş."}
            </p>
          </Card>

          {/* Referans */}
          <Card id="reference" className="p-4 shadow-sm mb-4 rounded-4">
            <h4 className="fw-bold mb-3 d-flex align-items-center">
              <FaBook className="me-2 text-primary" /> Referans
            </h4>
            <p className="text-muted">
              {formula.reference || "Referans bilgisi bulunmuyor."}
            </p>
          </Card>
        </Col>

        {/* SAĞ SİDEBAR */}
        <Col md={4}>
          <Card className="p-4 shadow-sm rounded-4 mb-4">
            <h5 className="fw-bold mb-3" style={{ color: "#2D8A7A" }}>
              Bilgi Özeti
            </h5>

            <p className="mb-2">
              <strong>Formül:</strong> <br />
              {formula.formulationName}
            </p>

            {formula.indication && (
              <p className="mb-2">
                <strong>Endikasyon:</strong> <br />
                {formula.indication}
              </p>
            )}

            <p className="mb-2">
              <strong>Oluşturulma Tarihi:</strong> <br />
              {new Date(formula.createdAt).toLocaleDateString("tr-TR")}
            </p>
          </Card>

          {/* ⭐ REKLAM ALANI */}
          <Card
            className="p-4 shadow-sm rounded-4 text-center"
            style={{
              background: "#f8fafc",
              border: "2px dashed #cdd6dd",
            }}
          >
            <h6 className="fw-bold mb-2">Reklam Alanı</h6>
            <p className="text-muted mb-0" style={{ fontSize: "0.9rem" }}>
              Bu alana reklam verebilirsiniz, bizimle iletişime geçin.
            </p>
          </Card>
        </Col>
      </Row>
    </UserLayout>
  );
};

export default FormulaDetailPage;
